// extracted by mini-css-extract-plugin
export default {"recos":"W1-z","productCardOverride":"X1-z","rowHasBadge":"Y1-z"};